import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { budgetForecastViewApi } from 'src/Services/API';

const useFetchBudgetForecastView = (year: number) => {
  const assetId = useCurrentAssetId();
  return useQuery({
    queryKey: ['fetch-budget-forecast-view', assetId, year],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return budgetForecastViewApi.getView(assetId, year);
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchBudgetForecastView;
